import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpdateVersion = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 184,
	height: 184,
	viewBox: "0 0 184 184",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .1,
			cx: 92,
			cy: 92,
			r: 91.8494,
			fill: "url(#paint0_radial_12544_86666)",
			fillOpacity: .2,
			stroke: "#561090",
			strokeWidth: .301149
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M155.849 92C155.849 127.816 127.038 156.849 91.5 156.849C55.9619 156.849 27.1506 127.816 27.1506 92C27.1506 56.1836 55.9619 27.1506 91.5 27.1506C127.038 27.1506 155.849 56.1836 155.849 92Z",
			fill: "url(#paint1_radial_12544_86666)",
			fillOpacity: .4,
			stroke: "#561090",
			strokeWidth: .301149
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_bddi_12544_86666)",
			children: /* @__PURE__ */ _jsx("circle", {
				cx: 92.25,
				cy: 92.25,
				r: 38.25,
				fill: "white",
				fillOpacity: .8,
				shapeRendering: "crispEdges"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_12544_86666)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M103.314 97.658L100.486 94.83L103.314 92.002C104.056 91.2591 104.646 90.3771 105.048 89.4065C105.45 88.4359 105.657 87.3956 105.657 86.345C105.657 85.2944 105.45 84.254 105.048 83.2834C104.646 82.3128 104.056 81.4309 103.314 80.688C102.571 79.9451 101.689 79.3558 100.718 78.9537C99.7475 78.5517 98.7071 78.3448 97.6565 78.3448C96.6059 78.3448 95.5656 78.5517 94.595 78.9537C93.6244 79.3558 92.7424 79.9451 91.9995 80.688L89.1715 83.516L86.3435 80.688L89.1715 77.86C91.4282 75.6398 94.4707 74.4013 97.6363 74.4142C100.802 74.4271 103.834 75.6903 106.073 77.9288C108.311 80.1672 109.574 83.1996 109.587 86.3652C109.6 89.5308 108.362 92.5733 106.142 94.83L103.314 97.658ZM97.6555 103.316L94.8275 106.144C93.7166 107.273 92.393 108.171 90.9333 108.786C89.4735 109.401 87.9064 109.722 86.3223 109.728C84.7382 109.734 83.1686 109.427 81.7038 108.824C80.2391 108.221 78.9083 107.333 77.7882 106.213C76.668 105.093 75.7808 103.762 75.1776 102.298C74.5743 100.833 74.2671 99.2633 74.2735 97.6792C74.28 96.0951 74.6 94.528 75.2151 93.0682C75.8303 91.6085 76.7283 90.2849 77.8575 89.174L80.6855 86.346L83.5135 89.174L80.6855 92.002C79.9427 92.7449 79.3534 93.6268 78.9513 94.5974C78.5493 95.568 78.3423 96.6084 78.3423 97.659C78.3423 98.7096 78.5493 99.7499 78.9513 100.721C79.3534 101.691 79.9427 102.573 80.6855 103.316C81.4284 104.059 82.3104 104.648 83.281 105.05C84.2516 105.452 85.2919 105.659 86.3425 105.659C87.3931 105.659 88.4335 105.452 89.4041 105.05C90.3747 104.648 91.2567 104.059 91.9995 103.316L94.8275 100.488L97.6555 103.316ZM97.6555 83.516L100.486 86.346L86.3435 100.486L83.5135 97.658L97.6555 83.518V83.516Z",
				fill: "#561090"
			})
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 122,
			cy: 63,
			r: 13,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip1_12544_86666)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M121.999 79.6654C112.794 79.6654 105.332 72.2037 105.332 62.9987C105.332 53.7937 112.794 46.332 121.999 46.332C131.204 46.332 138.665 53.7937 138.665 62.9987C138.665 72.2037 131.204 79.6654 121.999 79.6654ZM120.337 69.6654L132.12 57.8804L129.764 55.5237L120.337 64.952L115.622 60.237L113.265 62.5937L120.337 69.6654Z",
				fill: "#4CBA78"
			})
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_bddi_12544_86666",
				x: 26,
				y: 44,
				width: 132.5,
				height: 132.5,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feGaussianBlur", {
						in: "BackgroundImageFix",
						stdDeviation: 2.5
					}),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "SourceAlpha",
						operator: "in",
						result: "effect1_backgroundBlur_12544_86666"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: .5 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.2 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_backgroundBlur_12544_86666",
						result: "effect2_dropShadow_12544_86666"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 18 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 14 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0705882 0 0 0 0 0.0117647 0 0 0 0 0.243137 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect2_dropShadow_12544_86666",
						result: "effect3_dropShadow_12544_86666"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect3_dropShadow_12544_86666",
						result: "shape"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", {}),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "arithmetic",
						k2: -1,
						k3: 1
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.55 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "shape",
						result: "effect4_innerShadow_12544_86666"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_12544_86666",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(92 92) rotate(90) scale(92)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_12544_86666",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(91.5 92) rotate(90) scale(65 64.5)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .838542,
					stopColor: "#561090",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#561090"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_12544_86666",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 48,
					height: 48,
					fill: "white",
					transform: "translate(68 68)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_12544_86666",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 40,
					height: 40,
					fill: "white",
					transform: "translate(102 43)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgUpdateVersion);
export default ForwardRef;
